import { render, staticRenderFns } from "./YwArtificialPatrolStlModal.vue?vue&type=template&id=18f1ba98&"
import script from "./YwArtificialPatrolStlModal.vue?vue&type=script&lang=js&"
export * from "./YwArtificialPatrolStlModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports